module.exports = __webpack_public_path__ + "static/interview-f8d013d0d5beb370d459411111c9c2db.png";